// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_grooved_shell/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_grooved_shell: ModuleSchema = {
  "id": "core_grooved_shell",
  "uniqueId": "B3D_GRV01",
  "createdAt": "2026-10-10T14:45:48.249Z",
  "updatedAt": "2026-10-11T03:10:49.741Z",
  "label": "Round Grooved Shell",
  "description": "Khối trụ mẫu để minh hoạ rãnh lõm tròn (U-groove) quanh vỏ ngoài.",
  "category": "core_geometry",
  "tags": [
    "core",
    "geometry",
    "shell",
    "groove",
    "recess"
  ],
  "sliders": [
    {
      "key": "radius",
      "label": "Shell Radius",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 28,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Shell Height",
      "min": 8,
      "max": 80,
      "step": 1,
      "default": 24,
      "unit": "mm"
    },
    {
      "key": "grooveCount",
      "label": "Number of Vertical Grooves",
      "min": 0,
      "max": 48,
      "step": 1,
      "default": 24
    },
    {
      "key": "grooveSpacing",
      "label": "Groove End Margin",
      "min": 0,
      "max": 12,
      "step": 0.5,
      "default": 1.5,
      "unit": "mm"
    },
    {
      "key": "grooveWidth",
      "label": "Vertical Groove Width",
      "min": 0.4,
      "max": 8,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    },
    {
      "key": "grooveDepth",
      "label": "Recessed Groove Depth",
      "min": 0,
      "max": 10,
      "step": 0.1,
      "default": 1.2,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "shell",
      "label": "Round Grooved Shell",
      "default": "#ffffff",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "name": "Round Grooved Shell",
      "parts": [
        {
          "name": "Round Grooved Shell",
          "groupId": 0
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "name": "Round Grooved Shell",
      "groupId": 0
    }
  ]
};
